<div class="customers">
    <div class="row">
        <div class="col-sm-12">
            <div class="divDimension">
                <div class="row">
                    <div class="col-sm-1" [ngClass]="'color-back-area-' + areaData.orden" *ngIf="isCollapsed" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;color: antiquewhite;">
                        <p style="padding: 20px;margin-left: 25px;font-weight: bold;">{{areaData.orden}}</p>
                    </div>
                    <div class="col-sm-1" [ngClass]="'color-back-area-' + areaData.orden" *ngIf="!isCollapsed" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                    color: antiquewhite;">
                        <p style="padding: 20px;margin-left: 25px;font-weight: bold;">{{areaData.orden}}</p>
                    </div>
                    <div class="col-sm-10">
                        <p class="dataFecha" style="margin: 20px;">Dimensión {{areaData.area}}</p>
                    </div>
                    <div class="col-sm-1 ">
                        <button class="btn-collapser" style="margin: 10px;" [ngClass]="'color-area-' + areaData.orden" *ngIf="isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                        <button class="btn-collapser" style="margin: 10px;" [ngClass]="'color-area-' + areaData.orden" *ngIf="!isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                    </div>
                    <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
                        <div class="row">
                            <div *ngFor="let subdimensionData of areaData.subdimensiones; let indice=index">
                                <app-subdimension-anual-seguimiento [indice]="indice" [subdimensionData]="subdimensionData" [areaNumber]="areaData.orden"></app-subdimension-anual-seguimiento>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>